<app-block-wrapper [_editable]="_editable" [style]="style">
  <div class="point-list">
    <div class="point-list-item" *ngFor="let item of items" [appStoryblok]="item._editable">
      <h4>{{ item.title }}</h4>
      <ul>
        <li *ngFor="let point of item.points" [appStoryblok]="point._editable">
          <span>{{ point.text }}</span>
        </li>
      </ul>
    </div>
  </div>
</app-block-wrapper>
